<template>
  <div class="question-container" :class="device.isMobile ? 'question-container-mobile' : ''">
    <div class="question-item" v-for="(question, questionIndex) in questionData" :key="question.key">
      <div class="question-completion" v-if="question.type === 'completion'">
        <span class="question-guide" @click.stop="guideHandle(question)">引导问题<span class="question-guide-number">{{ questionIndex + 1 }}</span>：</span>
        <template v-for="(item, index) in question.content">
          <span :key="item.key" v-if="item.type === 'text'" class="question-text" :style="{
            fontStyle: item.fontItalic === 1 ? 'italic' : '',
          }">
            {{ item.text }}
          </span>
          <span :key="item.key" v-if="item.type === 'input'"><span
              :ref="item.key"
              class="question-input"
              :class="item.seat && item.seat.length >= 10 ? 'question-input-width' : ''"
              contenteditable
              @click.stop="(e)=> { e.stopPropagation(); }"
              @blur="blur(questionIndex, index, item)"
              @input="input(questionIndex, index, item)"
              @focus="focus(item)"
            ></span><span class="question-seat" @click.stop="clickSeat(item)">{{ item.seat }}</span>
          </span>
        </template>
      </div>
      <div class="question-short-answer" v-if="question.type === 'shortAnswer'">
        <span class="question-guide" @click.stop="guideHandle(question)">引导问题<span class="question-guide-number">{{ questionIndex + 1 }}</span>：</span>
        <span class="question-text">
          {{ question.questionText }}
        </span>
        <div class="question-textarea">
          <span>答：</span>
          <el-input v-model="question.answer" type="textarea" placeholder="请输入您的答案"></el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "workOrderQuestion",
  inject: [ 'saveHistoryPosition', 'chapterChange' ],
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  data() {
    return {
      questionData: []
    }
  },
  mounted() {
    this.questionData = this.content.content;
    this.questionData.forEach((question, questionIndex) => {
      if(question.type === 'completion') {
        question.content.forEach((item, index) => {
          if(item.type === 'input') {
            this.$set(this.content.content[questionIndex].content[index], 'seat', '          ');
          }
        })
      }
    })
  },
  methods: {
    clickSeat(item) {
      this.$refs[item.key] && this.$refs[item.key][0].focus(item);
    },
    // 聚焦时定位光标位置
    focus(item) {
      setTimeout(() => {
        this.setFocus(item.key, item.text.length);
      }, 0);
      document.addEventListener('keydown', function(e) {
        if(e.keyCode==13){
          e.preventDefault();//禁用回车的默认事件
        }
      })
    },
    // 失焦时再赋值一遍
    blur(questionIndex, index, item) {
      let obj = this.$refs[item.key][0];
      let textValue = obj.innerText
      
      this.$set(this.questionData[questionIndex].content[index], 'text', textValue);
      document.removeEventListener('keydown', function(e) {
        if(e.keyCode==13){
          e.preventDefault();//禁用回车的默认事件
        }
      })
    },
    // 输入时进行赋值
    input(questionIndex, index, item) {
      let obj = this.$refs[item.key][0];
      let textValue = obj.innerText;
      
      this.$set(this.questionData[questionIndex].content[index], 'text', textValue);

      let seatValue = ''
      if(10 - textValue.length > 0) {
        seatValue = new Array(10 - textValue.length).fill(" ").join('')
      }
      this.$set(this.questionData[questionIndex].content[index], 'seat', seatValue);
    },
    // 聚焦后把光标放到最后
    setFocus(key, index) {
      let obj = this.$refs[key][0];

      if (document.createRange) {
        // 获取选定对象
        let selection = getSelection();
        let range = document.createRange();

        range.setStart(obj.firstChild || obj, index);
        range.setEnd(obj.firstChild || obj, index);
        selection.removeAllRanges();
        selection.addRange(range);
      }
    },
    async guideHandle(question) {
      await this.saveHistoryPosition()
      await this.chapterChange(question.guideChapter, true)
      
      this.$nextTick(() => {
        setTimeout(()=> {
          // 导航滚动定位
          const element = document.getElementById(question.guide);
          if (element) {
            element.scrollIntoView({
              behavior: 'smooth', // 平滑滚动
              block: "start", // 顶部对齐
            });
          }
        }, 200);
      })
    },
    submitHandle() {
      return { question: 111 }
      // console.log(this.questionData)
      // let answerData = []
      // try {
      //   this.questionData.forEach((question, questionIndex) => {
      //     answerData.push({
      //       key: question.key,
      //       content: []
      //     })
      //     if(question.type === 'completion') {
      //       question.content.forEach(item => {
      //         if(item.type === 'input' && item.text === '') {
      //           throw `请填写引导问题${questionIndex + 1}`
      //         }else{
      //           answerData[questionIndex]
      //         }
      //       })
      //     }
      //   })
      // } catch(e) {
      //   this.$message.error(e)
      // }
      // return {answerData}
    },
  }
}
</script>

<style lang="scss" scoped>
.question-container{
  width: 660rem;
  margin-left: 16rem;
  margin-top: 18rem;
  box-shadow: 0px 0px 9px 0px rgba(210,210,210,0.8);
  padding: 43rem 26rem 26rem;

  .question-item{
    margin-bottom: 16rem;
    font-size: 18rem;
    line-height: 32rem;
    color: #333;

    .question-completion,.question-short-answer{
      user-select: none;
      .question-guide{
        user-select: none;
        color: #0482EC;
        text-decoration: underline;
        padding-right: 32rem;
        position: relative;

        .question-guide-number{
          user-select: none;
          font-family: 'Times New Roman';
        }

        &:after{
          content: '';
          width: 24rem;
          height: 24rem;
          position: absolute;
          right: 0;
          bottom: 0;
          background: url(~@/assets/images/books/book1/workOrder/guide.png) center center no-repeat;
          background-size: contain;
        }
      }
      .question-text{
        user-select: none;
      }
      .question-input{
        user-select: none;
        text-align: center;
        outline: none;
        text-decoration: underline;
        line-height: initial;
      }
      .question-input-width{
        display: inline-block;
        min-width: 1px;
      }
      .question-seat{
        user-select: none;
        white-space: pre;
        text-decoration: underline;
      }
    }
    .question-short-answer {

      .question-textarea{
        display: flex;

        >span{
          user-select: none;
        }

        /deep/.el-textarea{
          .el-textarea__inner{
            font-size: 18rem;
            height: 200rem;
            &:focus {
              border: 1px solid #0FC29A;
            }
          }
        }
      }
    }
  }
}
.question-container-mobile{
  .question-item{
    margin-bottom: 32rem;
    font-size: 28rem;
    line-height: 48rem;
    .question-completion,.question-short-answer{
      .question-guide{
        padding-right: 32rem;

        &:after{
          width: 32rem;
          height: 32rem;
        }
      }
    }
    .question-short-answer {
      .question-textarea{
        /deep/.el-textarea{
          .el-textarea__inner{
            font-size: 28rem;
            height: 200rem;
          }
        }
      }
    }
  }
}
</style>